const {Core, Events, Utils} = Global;
const { $toggleDisplay } = Utils;
const CN_ACTIVE = '!active';
const CN_LOADING = '!loading';

customElements.define('sticky-add-to-cart', class extends Core {

    elements = {
        $: ['observer-trigger', 'wrapper']
    }

    propTypes = {
        'sticky-bottom': Boolean
    }

    render() {
        this.sub(Events.VARIANT_CHANGE, this._toggleLoading(true));
        this.sub(Events.VARIANT_UPDATE, this._toggleLoading(false));
        this.sub(Events.VARIANT_UNAVAILABLE, this._handleVariantUnavailability);

        if (this.prop('sticky-bottom')) {
            this._setBodyOffset();
        }
        
        this._handleTrigger();
        
        // Forzar visibilidad en móvil al cargar
        this._forceMobileVisibility();
        
        // Escuchar cambios de tamaño de pantalla
        window.addEventListener('resize', this._forceMobileVisibility.bind(this));
    }

    _forceMobileVisibility() {
        // Forzar que el sticky sea visible en móvil (<= 768px)
        if (window.innerWidth <= 768) {
            this.active = true; // Siempre activo en móvil
        } else {
            // En desktop, permitir que el observer maneje la visibilidad
            // No hacemos nada, el observer se encargará
        }
    }

    _handleTrigger() {
        // OPCIÓN 1: Buscar usando el section-id proporcionado en el componente sticky
        const sectionId = this.getAttribute('section-id');
        
        // El section-id es 'template--21573253988441__main'
        // En el DOM, la sección tiene ID: 'shopify-section-template--21573253988441__main'
        const sectionSelector = `#shopify-section-${sectionId}`;
        const section = document.querySelector(sectionSelector);
        
        if (!section) {
            console.warn('Sticky Add to Cart: No se encontró la sección con selector:', sectionSelector);
            
            // OPCIÓN 2: Buscar de forma más general si la primera opción falla
            this._findFormWithAlternativeMethod();
            return;
        }
        
        // Buscar el formulario dentro de la sección
        // Nota: el selector .#product-form-add-to-cart tiene un # al inicio, que es parte de la clase
        const addToCartForm = section.querySelector('.\\#product-form-add-to-cart');
        
        if (!addToCartForm) {
            console.warn('Sticky Add to Cart: No se encontró el formulario de compra');
            // Intentar buscar con selectores alternativos
            const alternativeForm = section.querySelector('[data-element="to-cart-button"]')?.closest('form') || 
                                    section.querySelector('product-to-cart')?.closest('.form');
            
            if (alternativeForm) {
                this._observeElement(alternativeForm);
                return;
            }
            return;
        }
        
        this._observeElement(addToCartForm);
    }

    _findFormWithAlternativeMethod() {
        // Intentar encontrar el formulario de otras maneras
        
        // Método 1: Buscar por el botón "Añadir al carrito"
        const addToCartButton = document.querySelector('[data-element="to-cart-button"]');
        if (addToCartButton) {
            const form = addToCartButton.closest('form') || addToCartButton.closest('.form');
            if (form) {
                this._observeElement(form);
                return;
            }
        }
        
        // Método 2: Buscar por la clase del formulario de producto
        const productForm = document.querySelector('form.shopify-product-form');
        if (productForm) {
            const formContainer = productForm.querySelector('.form') || productForm;
            this._observeElement(formContainer);
            return;
        }
        
        // Método 3: Buscar cualquier elemento con la clase específica
        const formElement = document.querySelector('.\\#product-form-add-to-cart');
        if (formElement) {
            this._observeElement(formElement);
            return;
        }
        
        console.warn('Sticky Add to Cart: No se pudo encontrar ningún formulario de compra');
    }

    _observeElement(element) {
        this.observer = new IntersectionObserver(([entry]) => { 
            // Solo actualizar la visibilidad en desktop
            if (window.innerWidth > 768) {
                // Activar sticky bar
                this.active = !entry.isIntersecting && entry.boundingClientRect.top <= 0;
            }
            // En móvil, no cambiar el estado porque ya lo forzamos a true
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });
        
        this.observer.observe(element);
        //console.log('Sticky Add to Cart: Observando elemento:', element);
    }

    _setBodyOffset() {
        document.body.style.setProperty('--bottom-offset', `${this.$('wrapper').offsetHeight}px`);
    }

    _toggleLoading(state) {
        return () => {
            this.classList.toggle(CN_LOADING, state);
        }
    }

    _handleVariantUnavailability(state) {
        $toggleDisplay(this, !state);
    }

    set active(state) {
        this.classList.toggle(CN_ACTIVE, state);
    }
})